import React from 'react';
import FormDialog from '../../../library/form/components/FormDialog';
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormCheckbox from '../../../library/form/components/FormCheckbox';
import FormLabel from '../../../library/form/components/FormLabel';
import FormRichText from '../../../library/form/components/FormRichText';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormTitle from '../../../library/form/components/FormTitle';
import FormWrapper from '../../../library/form/components/FormWrapper';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormDropDown from '../../../library/form/components/FormDropDown';
import FormROValue from '../../../library/form/components/FormROValue1';

const InvItemDetailStoneEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ height: '550px' }}
            contentStyle={{ height: '450px', width: "730px" }}
            formTitle={<FormTitle formObject={formObject} value='Order Item' />}
            formObject={formObject} >
            <div id="invitemDetailMain" className="uiitemDetailMain" >
                <div className="uiROHeader">
                    {/* <FormWrapper customWrapper="div" wrapperStyle={{ display: "inline-block" }} formObject={formObject} rowKey="" action={{ paramName: "itemDetailROContainer" }} >
                        <FormAttachment formObject={formObject} rowKey="" action={{ InputType: "i", paramName: "itemImage" }} />
                        
                    </FormWrapper> */}
                    <div className="uiFlexBox">
                        <div className="uiFlexBox3">
                            <span className="">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemMaster" }} value="Stone" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" roClass="" style={{ width: "130px" }} placeholder="Stone Name"
                                action={{ InputType: "ac", paramName: "itemMaster", acMethod: "Item", acDepCtrl: { dtid: '%dataList.valLDT', level: 1 } }}
                            />
                            <FormInput formObject={formObject} rowKey="" className="uiInput" roClass="" style={{ width: "70px" }} placeholder="Quality"
                                action={{ InputType: "ac", paramName: "itemQuality", acMethod: "StoneQualityInItem", acDepCtrl: { dparam: '%dataList.valLCat', itemTypeId: '#itemType', itemId: '#itemMaster' } }}
                            />
                            <FormInput formObject={formObject} rowKey="" className="uiInput" roClass="" style={{ width: "90px" }} placeholder="Shape"
                                action={{ InputType: "ac", paramName: "itemShape", acMethod: "StoneShapeInItem", acDepCtrl: { dparam: '%dataList.valLCat', itemTypeId: '#itemType', itemId: '#itemMaster', itemQualityId: '#itemQuality' } }}
                            />
                        </div>
                        <div className="uiFlexBox3">
                            <span className="">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemWidth" }} value="Wd" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal50" placeholder="Width"
                                action={{ InputType: "ac", paramName: "itemWidth", acMethod: "StoneWidthInItem", acDepCtrl: { itemTypeId: '#itemType', itemId: '#itemMaster', itemQualityId: '#itemQuality', itemShapeId: '#itemShape' } }}
                            />
                            <span className="">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemLength" }} value="Ln" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal50" placeholder="Length"
                                action={{ InputType: "ac", paramName: "itemLength", acMethod: "StoneLengthInItem", acDepCtrl: { itemTypeId: '#itemType', itemId: '#itemMaster', itemQualityId: '#itemQuality', itemShapeId: '#itemShape', itemWidth: '#itemWidth' } }}
                            />
                            <span className="">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemHeight" }} value="Ht" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiVal50" placeholder="Height"
                                action={{ InputType: "ac", paramName: "itemHeight", acMethod: "StoneHeightInItem", acDepCtrl: { itemTypeId: '#itemType', itemId: '#itemMaster', itemQualityId: '#itemQuality', itemShapeId: '#itemShape', itemWidth: '#itemWidth', itemLength: '#itemLength' } }}
                            />
                        </div>
                        <FormWrapper customWrapper="div" wrapperStyle={{ display: "inline-block" }} formObject={formObject} rowKey="" action={{ paramName: "itemSearchContainer" }} >
                            <FormButton formObject={formObject} rowKey="" className="uiActionButton uiSpacerH5" text={<SarasTrans value="Find Stone" />}
                                action={{
                                    actionId: "refresh",  actionParam: {
                                        changeitem: 1, itemTypId: "1002", itemId: "#itemMaster", pathKey: "stone",
                                        newItemQualityId: "#itemQuality", newItemShapeId: "#itemShape", newItemWidth: "#itemWidth", newItemLength: "#itemLength", newItemHeight: "#itemHeight"
                                    }
                                }}
                            />
                        </FormWrapper>
                    </div>
                    <span className="uiLblInLine" style={{ display: "none" }}>
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "transCat" }} value="Category" />
                    </span>
                    <FormInput formObject={formObject} rowKey="" className="uiInput" style={{ display: "none" }}
                        action={{ InputType: "ac", paramName: "transCat", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                    />
                </div>
                <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "itemQtyContainer" }} >
                    <div>
                        <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "itemCostContainer1" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "priceType" }} value="Price Type" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{
                                InputType: "ac", actionId: "refresh",
                                paramName: "priceType", acMethod: "PriceType", actionParam: { updateNetAmount: "1" }
                            }}
                            />
                        </FormWrapper>
                        <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "itemSalesContainer1" }} >
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taxTemplate" }} value="Tax" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" action={{
                                InputType: "ac", actionId: "refresh", paramName: "taxTemplate",
                                acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' }, actionParam: { updateNetAmount: "1" }
                            }}
                            />
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "includesTax" }} value="Price includes Tax" />
                            </span>
                            <FormCheckbox formObject={formObject} rowKey=''
                                action={{ InputType: "onOff", actionId: "refresh", paramName: "includesTax", actionParam: { updateNetAmount: "1" } }}
                            />
                        </FormWrapper>
                    </div>
                    <div>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qty1" }} value="Quantity" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                            action={{ InputType: "input", actionId: "refresh", paramName: "qty1", actionParam: { formulaSource: "QT1", updateNetAmount: "1" } }} />
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qty1uom" }} />
                        <FormWrapper customWrapper="div" wrapperClass="uiInline" formObject={formObject} rowKey="" action={{ paramName: "itemQty2Container" }} >
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qty2" }} value="and" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                                action={{ InputType: "input", actionId: "refresh", paramName: "qty2", actionParam: { formulaSource: "QT2", updateNetAmount: "1" } }} />
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qty2uom" }} />
                        </FormWrapper>
                    </div>
                </FormWrapper>
                <div>
                    <ul className="uiItemPopupForm">
                        <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "itemCostContainer2" }} >
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "unitCost" }} >
                                <div className="uiColumn"> 
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "unitCost" }} value="Cost" />
                                    </span>
                                    <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "unitCost"}} />
                                </div>
                            </FormWrapper>
                            <li>
                                <div className="uiColumn">
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "unitPrice" }} value="Unit Price" />
                                    </span>
                                    <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                                        action={{ InputType: "input", actionId: "refresh", paramName: "unitPrice", actionParam: { formulaSource: "UP", updateNetAmount: "1" } }} />
                                    <span className="uiLblInLine">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sellPriceUnit" }} value="per" />
                                    </span>
                                    <FormDropDown formObject={formObject} rowKey="" action={{ actionId: "refresh", paramName: "sellPriceUnit", actionParam: { formulaSource: "UP", updateNetAmount: "1" } }} />
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "priceUnit" }} className='uiVal' />
                                </div>
                                <div className="uiColumn">
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "amtAfterQC" }} value="Total Amount" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "amtAfterQC" }} className='uiVal' />
                                </div>
                            </li>
                        </FormWrapper>
                        <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "itemSalesContainer2" }} >
                        <li>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "discAmt" }} value="Discount" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput uiSpacerR2" maxlength="24"
                                    action={{ InputType: "input", actionId: "refresh", paramName: "discAmt", actionParam: { formulaSource: "DSC", updateNetAmount: "1" } }}
                                />
                                <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24" style={{ width: "50px" }}
                                    action={{ InputType: "input", actionId: "refresh", paramName: "discPerc", actionParam: { formulaSource: "DSCP", updateNetAmount: "1" } }}
                                />
                                <SarasTrans value="%" />
                            </div>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "netAmt" }} value="Before Tax" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "netAmt" }} className='uiVal' />
                            </div>
                        </li>
                        <li>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sellingAmt" }} value="Selling Price" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                                    action={{ InputType: "input", actionId: "refresh", paramName: "sellingAmt", actionParam: { formulaSource: "SP", updateNetAmount: "1" } }}
                                />
                            </div>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "grandAmt" }} value="Total After Tax" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "grandAmt" }} className='uiVal uiHighlightBlue' />
                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "totalTaxAmt" }} value="Tax" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "totalTaxAmt" }} className='uiVal' />
                            </div>
                        </li>
                        </FormWrapper>
                    </ul>
                </div>
                <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "sectionMiscContainer" }} >
                    <ul className="uiItemPopupForm">
                        <li>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refNo" }} value="Reference No" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className=""
                                    action={{ InputType: "input", paramName: "refNo" }}
                                />
                            </div>
                            <div className="uiColumn">
                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "stockProfile" }} value="Profile" />
                                </span>
                                <FormInput format="#" formObject={formObject} rowKey="" className="uiInput" style={{width:"250px"}} 
                                    action={{
                                        InputType: "ac", paramName: "stockProfile", acMethod: "ProfileName", actionId: "refresh", actionParam: { updateProfile: 1 },
                                        acDepCtrl: { dparam: '%dataList.valLDT', reqPerm: 1 }
                                    }}
                                />
                            </div>
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "itemName" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemName" }} value="Reference Name" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInputLong"
                                action={{ InputType: "input", paramName: "itemName" }}
                            />
                        </FormWrapper>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemDesc" }} value="Description" />
                            </span>
                            <FormRichText formObject={formObject} rowKey="" id="delInstTxt" className="uiFrmText" rows="3" cols="82" maxlength="1000"
                                action={{ paramName: "itemDesc" }}
                            />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "packageContainer" }} >
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qtyPackage" }} value="Packing Qty" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                                    action={{ InputType: "input", paramName: "qtyPackage" }}
                                />
                            </div>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "packageUnit" }} value="Packing Unit" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" id="deliveryModeTxt" action={{
                                    InputType: "ac",
                                    actionId: "refresh", paramName: "packageUnit", acMethod: "Units", actionParam: { updateNetAmount: "1" }
                                }}
                                />
                            </div>
                        </FormWrapper>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "serviceDateContainer" }} >
                            <span className="uiLbl"> ,
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "fromDate" }} value="From Date" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="relationSince" className="uiInput"
                                action={{ InputType: "dp", paramName: "fromDate" }}
                            />

                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "toDate" }} value="To Date" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" id="relationSince" className="uiInput"
                                action={{ InputType: "dp", paramName: "toDate" }}
                            />
                        </FormWrapper>
                    </ul>
                </FormWrapper>
            </div>
        </FormDialog>

    )
}

export default withView(InvItemDetailStoneEditor, "itemDetail", "itemDetail,invTrnFooter")